import { useEffect } from 'react'
import { Modal } from 'medere-ui-framework'
import { ContractHonorariumListItemDTO } from '../../../dto/contractHonorarium/ContractHonorariumDTO'
import { describeValidity } from '../contractHonorariumFormat'
import { describeRow } from './describeRow'

interface DeleteContractHonorariumModalProps {
  visible: boolean
  contractHonorarium: ContractHonorariumListItemDTO | null
  confirming: boolean
  onCancel: () => void
  onConfirm: () => void
}

export default function DeleteContractHonorariumModal({
  visible,
  contractHonorarium,
  confirming,
  onCancel,
  onConfirm,
}: Readonly<DeleteContractHonorariumModalProps>) {
  useEffect(() => {
    if (!visible) return
    const timer = window.setTimeout(() => {
      const cancelButton = document.querySelector('.chd-delete-modal .modalFooter .buttonMain3')
      if (cancelButton instanceof HTMLElement) cancelButton.focus()
    }, 50)
    return () => window.clearTimeout(timer)
  }, [visible])

  return (
    <Modal
      visible={visible}
      setVisible={(nextVisible) => {
        if (!nextVisible) onCancel()
      }}
      header={<span className='chd-modal-title'>¿Eliminar distribución?</span>}
      width='w-medium'
      className='chd-modal chd-delete-modal'
      footerButtonLeftText='Cancelar'
      onClickLeftBtn={onCancel}
      footerButtonRightText='Eliminar'
      onClickRightBtn={onConfirm}
      rightButtonDisabled={confirming}
    >
      {contractHonorarium && (
        <p className='chd-confirm-text'>
          Se va a eliminar la distribución de <strong>{describeRow(contractHonorarium)}</strong>, que todavía no
          entró en vigencia ({describeValidity(contractHonorarium.datestart, contractHonorarium.dateend)}).
          No se puede deshacer.
        </p>
      )}
    </Modal>
  )
}
